
import PropTypes from "prop-types";
import React, {useState} from "react";
import { Link } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";
import GuiaPopup from '../../components/GuidePopup';
const NavMenu = ({ strings, menuWhiteClass, sidebarMenu }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  return (
    <div
    className={` ${
      sidebarMenu
      ? "sidebar-menu"
      : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
    } `}
    >
    <GuiaPopup open={show} onClose={handleClose} />
      <nav>
        <ul>
          <li>
            <Link to={process.env.PUBLIC_URL + "/"}>
              Inicio
            </Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + "/paseos"}>
              {" "}
              Paseos
            </Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + "#guia"} onClick={() => setShow(true)}>
              Mi guía gratis
            </Link>
          </li>
          <li>
            <Link to={process.env.PUBLIC_URL + "/contact"}>
            Contacto comercial
            </Link>
          </li>
          <li>
          <Link to={process.env.PUBLIC_URL + "/blog"}>
          Blog
            </Link>
            
          </li>
        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
  strings: PropTypes.object
};

export default multilanguage(NavMenu);
